<div class="my-account-main-container">
  <my-account-greeting class="mobile-greeting"></my-account-greeting>

  <div class="sidebar-nav-container" [ngClass]="{ hidden: !this.isShowed }">
    <div class="sidebar-arrow--left" (click)="moveToLeft()">
      <em class="fas fa-angle-left sidebar-arrow"></em>
    </div>
    <nav class="sidebar-list-container">
      <ul class="sidebar-list">
        <li *ngFor="let link of navigationLinks" class="sidebar-item">
          <a
            class="sidebar-link my-account-tertiary-link"
            [routerLink]="link.url"
            (click)="scrollIntoView($event)"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            ><span
              class="sidebar-img"
              [innerHTML]="link.svg | sanitize: 'html'"
            ></span
            ><span class="sidebar-span-link">{{
              link.key | translate
            }}</span></a
          >
        </li>
      </ul>
    </nav>
    <div class="sidebar-arrow--right" (click)="moveToRight()">
      <em class="fas fa-angle-right sidebar-arrow"></em>
    </div>
  </div>

  <div class="sidebar-content">
    <router-outlet></router-outlet>
  </div>
</div>
